var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-aos":"fade-in","id":"not_found"}},[_c('div',{attrs:{"id":"content1"}},[_c('h2',[_vm._v("404 - PAGE NOT FOUND")]),_c('a',{attrs:{"href":"/"}},[_vm._v("... go to start page")])])])
}]

export { render, staticRenderFns }